import { Chip, Stack } from "@mui/material";
import React from "react";
import { GridValidRowModel } from "@mui/x-data-grid";
import { PlatformAlertSeverity } from "../../../Core/Api/Types/platform-alert-severity";

export type TableCellAlertSeverityProps = {
  data: GridValidRowModel;
  color?: "default" | "primary" | "success" | "info" | "error";
};

const TableCellAlertSeverity: React.FC<TableCellAlertSeverityProps> = (props) => {
  const value = props.data.value;
  let color: "default" | "primary" | "success" | "info" | "error" = props.color ? props.color : "primary";
  let text = "";
  text = value as string;

  switch (value) {
    case PlatformAlertSeverity.Alert || "Warning":
      color = "info";
      break;
    case PlatformAlertSeverity.Emmergency || "Critical":
      color = "error";
      break;
  }

  return (
    <Stack>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Chip
          label={text}
          component="span"
          variant="outlined"
          color={color}
          sx={{ ml: 0.5, verticalAlign: "baseline" }}
        />
      </Stack>
    </Stack>
  );
};

export default TableCellAlertSeverity;
